import axios from 'axios';
import { REVIEWS_WIDGET_DATA_KEY, REVIEWS_WIDGET_PREVIOUS_DATA_KEY } from '@/assets/dashboard/cache-keys';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {
    DATA_KEY: () => REVIEWS_WIDGET_DATA_KEY,
    PREVIOUS_DATA_KEY: () => REVIEWS_WIDGET_PREVIOUS_DATA_KEY
};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, properties, timeZone, socialTypes }) {
        const params = {
            range,
            timeZone,
            accountId,
            socialTypes,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/reviews', { params, encodeURI: true });
    }
};
